import { OrderErrorModal } from './OrderErrorModal';

export default OrderErrorModal;
export { OrderErrorModal };
